module.exports = __webpack_public_path__ + "img/3.f58487ef.jpg";